import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import * as d3 from "d3";
import HoverableIcon from "../Buttons/HoverableIcon ";
import { replaceDynamicValueLabel } from "../../util/utils";
import { store } from "../../util/store";
import ReusableAgGrid from "../AgGrid/AgGrid";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  titleContainer: {
    width: "100%",
  },
}));

const DrilldownBody = (props) => {
  const [exportTrigger, setExportTrigger] = useState(0); // Each time we click, the number changes, triggering the useEffect in the child.

  const classes = useStyle();
  const Symbol = store.getState();
  const Currency_Symbol = Symbol.app.user.Currency;

  const onCellClicked = (e) =>
    props.handleSecondLevelDrilldown
      ? props.handleSecondLevelDrilldown("drilldownOppId", e.data.Opp_ID)
      : "";

  const handleExport = () => {
    // Each time we click, the number changes, triggering the useEffect in the child.
    setExportTrigger((prevCount) => prevCount + 1);
  };

  let acvLabel = props.acvName ? `${props.acvName}:` : "ACV:";
  if (props.Value_Label) {
    acvLabel = replaceDynamicValueLabel(acvLabel, props.Value_Label);
  }

  console.log(acvLabel, props.Value_Label, "drilldown_acv");

  return (
    <Grid container className={classes.root}>
      {props.body ? (
        <React.Fragment>
          <Grid
            container
            justify="space-betweeen"
            className={classes.titleContainer}
            xs={12}
          >
            <Grid
              item
              container
              xs={10}
              justify="flex-start"
              alignItems="flex-end"
            >
              <Typography variant="body1" style={{ fontWeight: "600" }}>
                Number of opportunities:
                <span data-test="count">
                  {d3.format(",")(props.body.count_acv[0].count)}
                </span>
                {props.body.count_acv &&
                  props.body.count_acv[0].hasOwnProperty("Total_Quantity") && (
                    <>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Seats:
                      <span data-test="seats">
                        {[null, undefined, ""].includes(
                          props.body.count_acv[0].Total_Quantity
                        )
                          ? 0
                          : d3.format(",")(
                              props.body.count_acv[0].Total_Quantity
                            )}
                      </span>
                    </>
                  )}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {acvLabel}{" "}
                {`${Currency_Symbol}`}{" "}
                <span data-test="acv">
                  {d3.format(",")(
                    Math.round(props.body.count_acv[0].acv).toString()
                  )}
                </span>
                <>
                  {props.showQuota ? (
                    <>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Quota:{" "}
                      <span data-test="connectors">
                        {![undefined, null].includes(
                          props.body.count_acv[0].Quota
                        )
                          ? d3.format(",")(
                              Math.round(
                                props.body.count_acv[0].Quota
                              ).toString()
                            )
                          : "-"}
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </>
                <>
                  {props.showCoonectorValue ? (
                    <>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Number of
                      Connectors:{" "}
                      <span data-test="connectors">
                        {d3.format(",")(
                          Math.round(
                            ![undefined, null].includes(
                              props.body.count_acv[0].connectorCount
                            )
                              ? props.body.count_acv[0].connectorCount
                              : 0
                          ).toString()
                        )}
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              </Typography>
            </Grid>
            <Grid
              direction="column"
              item
              container
              xs={2}
              justify="flex-end"
              alignItems="flex-end"
              alignContent="flex-end"
            >
              <Grid item justify="flex-end" style={{ paddingBottom: "1rem" }}>
                <button style={{ border: "none" }} onClick={handleExport}>
                  <HoverableIcon />
                </button>
              </Grid>
            </Grid>
          </Grid>

          <ReusableAgGrid
            rowData={props.body.opportunities}
            columnConfig={props.body.columns}
            onCellClicked={onCellClicked}
            isExportable={true}
            header={props.header}
            rawColumnDataForExport={props.body.columns}
            exportTrigger={exportTrigger}
          />
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default DrilldownBody;
